"use client";

import Image from "next/image";
import cc from "@/public/anualidad/img/icons/credit-card-front-regular.svg";
import { useState } from "react";
import Modal from "@/components/ui/modal/Modal";
import AddMemberForm from "./AddMemberForm";

const AddMemberButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="flex items-center justify-center w-full px-4 py-4 text-sm font-medium text-white uppercase bg-indigo-600 border border-transparent rounded-md shadow-xs hover:bg-indigo-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        onClick={() => setOpen(true)}
      >
        <Image
          alt=""
          src={cc}
          className="w-5 h-5 mr-3 -ml-1"
          aria-hidden="true"
        />
        Quiero pagar mi anualidad
      </button>

      <Modal
        open={open}
        setOpen={setOpen}
        title="Ingresa los datos del miembro"
      >
        <div className="space-y-6">
          <p>
            Recuerda que solo puedes agregar personas que pertenezcan a tu
            nucleo familiar
          </p>
          <AddMemberForm setOpen={setOpen} />
        </div>
      </Modal>
    </>
  );
};

export default AddMemberButton;
